import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Departamento = () => {
  const navigate = useNavigate();

  const handleDeptoClick = (depto) => {
    localStorage.setItem("departamento", depto);
    navigate("/crear");
  };

  useEffect(() => {
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);

  const departamentos = [
    "Alta Verapaz", "Baja Verapaz", "Chimaltenango", "Chiquimula", "Guatemala",
    "El Progreso", "Escuintla", "Huehuetenango", "Izabal", "Jalapa", "Jutiapa",
    "Petén", "Quetzaltenango", "El Quiché", "Retalhuleu", "Sacatepéquez", "San Marcos",
    "Santa Rosa", "Sololá", "Suchitepéquez", "Totonicapán", "Zacapa"
  ];

  return (
    <motion.div
	    initial={{ y: "100%", opacity: 0 }}
	    animate={{ y: 0, opacity: 1 }}
	    exit={{ y: "100%", opacity: 0 }}
	    transition={{ duration: 0.7, ease: "easeInOut" }}
  	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
            <button className="back-btn" onClick={() => navigate("/registro")}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
                </svg>
            </button>
        </div>
        <h2 className="connections-title">Elige tu departamento</h2>
    </div>
      <div className="country-list">
        {departamentos.map((depto, i) => (
          <div className="country-item" key={i} onClick={() => handleDeptoClick(depto)}>
            <img src={`assets/flags/deptos/${i + 1}.png`} alt={depto} className="depto" />
            <span>{depto}</span>
            <span className="country-arrow">›</span>
          </div>
        ))}
      </div>
    </div>
    </motion.div>
  );
};

export default Departamento;
